import { useLocation } from 'react-router-dom';
import React, { useMemo, useState } from 'react';
import Container from '@mui/material/Container';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import CustomHeader from '../../General/CustomHeader';
import Page from '../../Layout/Page';
import FullScreenChartShell from '../FullScreenChartShell/FullScreenChartShell';
import useStyles from '../styles';
import RainfallChart from './RainfallChart';
import RainfallConfigContent from './RainfallConfigContent';
import { PRECIPITATION_NAME } from '../../../constants/graphs';
import { ReduxState } from '../../../types';
import { generateBreadcrumb } from '../utils';
import { ModalState, EMPTY_MODAL_STATE } from '../chartModal';

const Rainfall = ({ fullScreen }: { fullScreen?: boolean }) => {
  const classes = useStyles();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);
  const { selectedSector } = useSelector((state: ReduxState) => state.currentSector);

  const [modalState, setModalState] = useState<ModalState>(EMPTY_MODAL_STATE);
  const [conversationsRefreshCounter, setConversationsRefreshCounter] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const farmId = queryParams.get('farmId') || '';
  const sectorId = queryParams.get('sectorId') || '';

  const breadcrumb = useMemo(() => generateBreadcrumb(
    selectedFarm, selectedSector, PRECIPITATION_NAME, sectorId,
  ), [selectedFarm, selectedSector]);

  if (fullScreen) {
    return (
      <FullScreenChartShell title="Precipitaciones">
        {(h) => (
          <RainfallChart
            chartView="fullScreen"
            sectorId={sectorId}
            farmId={farmId}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            hideXValues={false}
            height={`${h}px`}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
            refreshTrigger={refreshTrigger}
          />
        )}
      </FullScreenChartShell>
    );
  }

  return (
    <Page className={classes.root} title='Configuración gráfico de precipitaciones'>
      <Container maxWidth={false}>
        <CustomHeader title={breadcrumb} />
        <Box mt={3}>
          <RainfallChart
            chartView="settings"
            sectorId={sectorId}
            farmId={farmId}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
            refreshTrigger={refreshTrigger}
          />
        </Box>
        <RainfallConfigContent
          sectorId={sectorId}
          setModalState={setModalState}
          refreshCounter={conversationsRefreshCounter}
          onConfigSaved={() => setRefreshTrigger((prev) => prev + 1)}
        />
      </Container>
    </Page>
  );
};

export default Rainfall;
